module.exports = __webpack_public_path__ + "assets/img/station7.983f5147.png";